import { FC } from "react";
import { FadeLoader } from "react-spinners";
import styled from "styled-components";
import { CgLoadbarDoc } from "react-icons/cg";

interface TotalsInfoCardProps {
  // icon: React.ReactElement<IconType>;
  titleCard: string;
  totalValue: string;
  isLoading: boolean;
}

const InfoCard: FC<TotalsInfoCardProps> = ({
  titleCard,
  totalValue,
  isLoading,
}) => {
  return (
    <TotalsInfoCardContainer>
      <span><CgLoadbarDoc /></span>

      <div>
        <p>{titleCard}</p>
        {isLoading ? <span><FadeLoader /></span> : <span>{totalValue}</span>}
      </div>
    </TotalsInfoCardContainer>
  );
};


export const TotalsInfoCardContainer = styled.div`
  max-width: 536px;
  height: fit-content;

  display: flex;
  position: relative;
  align-items: center;
  flex: 1;

  box-shadow: ${({ theme }) => theme.shadow.default};
  border-radius: 16px;

  padding: 16px;
  margin-top: 24px;

  > span {
    border-radius: 8px;
    width: 100%;
    max-width: 56px;
    height: 56px;
    background-color: ${({ theme }) => theme.colors.orange.primary};

    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 36px;
      height: 36px;
      color: ${({ theme }) => theme.colors.white};
    }
  }

  > div {
    width: 100%;
    // height: 98%;

    display: flex;
    flex-direction: column;
    align-items: end;

    p {
      font-weight: 500;
      font-size: 15px;
      color: ${({ theme }) => theme.colors.gray[600]};
    }
    span {
      margin-top: 8px;
      font-weight: 800;
      font-size: 20px;
      color: ${({ theme }) => theme.colors.gray[700]};
    }
  }
`;

export default InfoCard;